import {
  TOGGLE_EDIT_PASSWORD_MODAL,
  TOGGLE_GENERATE_PROMOCODES_MODAL,
  TOGGLE_REGISTER_USER_MODAL
} from './types'

export const toggleEditPasswordModal = (payload = {}) => ({
  type: TOGGLE_EDIT_PASSWORD_MODAL,
  payload
})

export const toggleGeneratePromoCodesModal = (payload = {}) => ({
  type: TOGGLE_GENERATE_PROMOCODES_MODAL,
  payload
})

export const toggleRegisterUserModal = (payload = {}) => ({
  type: TOGGLE_REGISTER_USER_MODAL,
  payload
})
